export default "__VITE_ASSET__qVETJqQr__"